export class ExpansionData {
    constructor(
        public id: number,
        public name: string,
        public slug: string,
        public shortName: string
    ) {}
}
